import { render, staticRenderFns } from "./OutcomePlanQuestionnaire.vue?vue&type=template&id=229bb597&scoped=true"
import script from "./OutcomePlanQuestionnaire.vue?vue&type=script&lang=js"
export * from "./OutcomePlanQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./OutcomePlanQuestionnaire.vue?vue&type=style&index=0&id=229bb597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bb597",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QCard,QCheckbox});
